module.exports = __webpack_public_path__ + "img/round.3dd44ced.png";